// extracted by mini-css-extract-plugin
export var actionButton = "_8s-1";
export var actionButtons = "_8s-2";
export var actions = "_8s-0";
export var aiUnread = "_8s-10";
export var alignCenter = "_8s-h";
export var backWrapper = "_8s-3";
export var cellContainer = "_8s-4";
export var checkboxContainer = "_8s-5";
export var contentContainer = "_8s-6";
export var contentHeader = "_8s-8";
export var conversationsTableWrapper = "_8s-s";
export var draftReplyBadgeContainer = "_8s-m";
export var dropdownItem = "_8s-b";
export var dropdownItemsContainer = "_8s-a";
export var dropdownTitle = "_8s-c";
export var errorIcon = "_8s-7";
export var filter = "_8s-d";
export var gray = "_8s-i";
export var headerActionButtons = "_8s-e";
export var headerCheckboxContainer = "_8s-f";
export var icon = "_8s-j";
export var menuContainer = "_8s-k";
export var noMoreTicketsIcon = "_8s-12";
export var noMoreTicketsSubText = "_8s-13";
export var oneLine = "_8s-l";
export var optionsButton = "_8s-n";
export var plus = "_8s-o";
export var portalButtonsWrapper = "_8s-g";
export var red = "_8s-p";
export var scrolledTop = "_8s-9";
export var search = "_8s-q";
export var selectedConversationsCount = "_8s-r";
export var spinner = "_8s-t";
export var strong = "_8s-u";
export var summaryCell = "_8s-v";
export var tableContainer = "_8s-11";
export var tagContainer = "_8s-w";
export var threeDots = "_8s-x";
export var twoLines = "_8s-y";
export var unread = "_8s-z";